/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Faq_DescriptionInputs */

const en_directory_faq_description = /** @type {(inputs: Directory_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers about product discovery, submissions, editorial review, and managing a Seek AI listing.`)
};

const zh_directory_faq_description = /** @type {(inputs: Directory_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`了解产品发现、提交、编辑审核以及管理 Seek AI 产品页的常见问题。`)
};

/**
* | output |
* | --- |
* | "Answers about product discovery, submissions, editorial review, and managing a Seek AI listing." |
*
* @param {Directory_Faq_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_faq_description = /** @type {((inputs?: Directory_Faq_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Faq_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_faq_description(inputs)
	return zh_directory_faq_description(inputs)
});
export { directory_faq_description as "directory.faq.description" }